import * as React from "react"
// helper
import { ISvgIcons } from "./helper"

export const FAQIcon: React.FC<ISvgIcons> = ({ className = "", ...rest }) => (
    <svg
        viewBox="0 0 25 25"
        className={`${className}`}
        stroke="currentColor"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...rest}
    >
        <path
            d="M17.75 18.6797H13.75L9.29999 21.6397C8.63999 22.0797 7.75 21.6098 7.75 20.8098V18.6797C4.75 18.6797 2.75 16.6797 2.75 13.6797V7.67969C2.75 4.67969 4.75 2.67969 7.75 2.67969H17.75C20.75 2.67969 22.75 4.67969 22.75 7.67969V13.6797C22.75 16.6797 20.75 18.6797 17.75 18.6797Z"
            strokeMiterlimit="10"
        />
        <path d="M12.7498 11.6104V11.4004C12.7498 10.7204 13.1698 10.3604 13.5898 10.0704C13.9998 9.79037 14.4098 9.43039 14.4098 8.77039C14.4098 7.85039 13.6698 7.11035 12.7498 7.11035C11.8298 7.11035 11.0898 7.85039 11.0898 8.77039" />
        <path d="M12.7455 14H12.7545" />
    </svg>
)
